/**
 * Whether an arriving API response has been superseded by a newer request.
 *
 * The Care endpoints are slow and uncancellable, so a response for one care
 * item, search or provider list can land after the user has already moved on to
 * another. Nothing in the Care reducers used to check for that, so the last
 * _response_ won rather than the last _request_ — which is how a detail page
 * ends up showing the previously searched drug (BASH-219) and how search
 * results for an abandoned query get merged into the current list (BASH-100).
 *
 * Each slice stamps the key it is waiting for onto state when the REQUEST
 * action fires, and passes the arriving response's key here before applying it.
 * The key is either a per-call nonce (see `getNextRequestId`, for slices that
 * hold a single entity) or a context identifier such as the search query (for
 * slices whose responses are merged, so that "show more" pagination still
 * merges into the list it belongs to).
 *
 * A response with no key at all — `undefined` — is always applied. Not every
 * action that reaches these reducers comes from a stamped action creator, and
 * an unstamped response makes no claim about which request it answers, so
 * there's nothing to compare. Only a response that identifies itself can be
 * recognised as stale.
 *
 * @param {string | null | undefined} responseKey - Key carried by the arriving
 *   response, from its `meta`.
 * @param {string | null} currentKey - Key the slice is currently waiting for.
 * @returns {boolean} True when the response should be discarded.
 */
export const isStaleResponse = (responseKey, currentKey) =>
  responseKey !== undefined && responseKey !== currentKey
